<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-data-table
            :headers="headers"
            :items="systemSettings"
            :loading="tableLoading"
          >
            <template v-slot:item.value="{ item }">
              <div v-if="item.key=='KATIMAS_WORKSPACE_INTEGRATION'">
                <span> {{ item.value == '1' ? 'Yes' : 'No' }} </span>
              </div>
              <div v-else-if="item.key=='BASED_COUNTRY'">
                {{ getCountryValue(item.value) }}
              </div>
              <div v-else-if="item.key=='LEAVE_ROLLOVER'">
                {{ getLeaveRolloverValue(item.value) }}
              </div>
              <div v-else>
                <span> {{ item.value }} </span>
              </div>
            </template>
            <template v-slot:item.default_value="{ item }">
              <div v-if="item.key=='KATIMAS_WORKSPACE_INTEGRATION'">
                <span> {{ item.default_value == '1' ? 'Yes' : 'No' }} </span>
              </div>
              <div v-else-if="item.key=='BASED_COUNTRY'">
                {{ getCountryValue(item.default_value) }}
              </div>
              <div v-else-if="item.key=='LEAVE_ROLLOVER'">
                {{ getLeaveRolloverValue(item.default_value) }}
              </div>
              <div v-else>
                <span> {{ item.default_value }} </span>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <setup-system-settings-dialog-edit
                v-if="$hasPermissionTo(['update system settings'])"
                :systemsetting="item"
                @updated="refreshData"
              />
            </template>
          </v-data-table>
        </v-card> 
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupSystemSettingsDialogEdit: () => import('@/components/hris/setup/system-settings/DialogEdit'),
    },
    metaInfo () {
      return {
        title: 'System Settings',
      }
    },
    data () {
      return {
        systemSettings: [],
        headers: [
          {
            text: 'Key',
            align: 'left',
            value: 'key',
          },
          {
            text: 'Description',
            align: 'left',
            value: 'description',
          },
          {
            text: 'Default Value',
            align: 'left',
            value: 'default_value',
          },
          {
            text: 'Value',
            align: 'left',
            value: 'value',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        tableLoading: true,
        country: null,
      }
    },
    created () {
      this.refreshData()
    },
    
    methods: {
      loadSystemSettings () {
        this.$api.systemSettings().list()
          .then(response => {
            this.systemSettings = response.data
            this.tableLoading = false
          })
      },
      getCountryValue (value) {
        if (!this.country) {
          this.$api.countries().show(value)
            .then(response => {
              this.country = response.data
            })
        }
        if (this.country) { return this.country.name }
      },
      getLeaveRolloverValue (value) {
        if (value === 'CALENDAR') { 
          return 'By Calendar year' // normal usage (lock leave, then rollover manually)
        // } else if (value === 'FINANCIAL') { // no details yet
        //   return 'By Financial year' 
        // } else if (value === 'ANNIVERSARY') { // will auto rollover all leave entitlement upon employee's anniversary
        //   return 'By Anniversary  year' 
        } else {
          return ''
        }
      },
      refreshData () {
        this.loadSystemSettings()
        this.country = null
      },
    },
  }
</script>
